import React from 'react';

import ArrowBack from '@nerdwallet/react-icon/material/ArrowBack';
import { CenteredContainer } from '@nerdwallet/currency/components/CenteredContainer';
import { Stack } from '@nerdwallet/currency/components/Stack';

import PageContainer from '@components/page-container/page-container';
import { SimplePageHeader } from '@components/page-header';
import { UserInsightEligibleModulesEnum } from '@generated-gql/generated-types';
import Paths from '@lib/paths';
import { SegmentPageView } from '@lib/segment';

import BottomLinks from '../components/bottom-links';
import CreditFactorsLocked from './components/credit-factors-locked';
import { CreditHeader } from '../components/credit-header';
import Insights from './components/insights';
import RewardsEmitter from './components/rewards-emitter';

const CreditScoreActivated: React.FC = () => (
  <>
    <SegmentPageView name="credit_score_activated">
      <PageContainer>
        <CenteredContainer>
          <Stack spacing="5">
            <SimplePageHeader
              backLinkIcon={ArrowBack}
              backLinkLabel="Home"
              isBackLinkVisible
              backLinkTo={Paths.DASHBOARD_HOME}
              title="Credit score"
            />
            <CreditHeader />
            <Insights
              analyticsPayload={{
                moduleName: 'why_did_my_score_change',
                sectionPosition: 1,
              }}
              eligibleModule={
                UserInsightEligibleModulesEnum.WhyDidMyScoreChange
              }
              title="See what changed"
              tooltip="We looked at the most recent changes to your credit score and crunched the numbers to find what impacted your score the most."
            />
            <Insights
              analyticsPayload={{
                moduleName: 'credit_booster',
                sectionPosition: 2,
              }}
              eligibleModule={UserInsightEligibleModulesEnum.CreditBooster}
              title="Build your score"
              tooltip="We looked at your credit and identified the best ways for you to build your score. These projections are estimates based off of your score today and data from people with similar credit scores."
            />
            <CreditFactorsLocked />
            <BottomLinks />
          </Stack>
        </CenteredContainer>
      </PageContainer>
    </SegmentPageView>
    <RewardsEmitter />
  </>
);

export default CreditScoreActivated;
